import { createContext } from 'react';

export interface SiteState {
  siteId: string;
  setSite: (siteId: string) => Promise<void>;
}

export const SiteContext = createContext<SiteState | null>(null);
